<template>
  <div class="est-no">
    <div class="est-linha" @click="expandido = !expandido">
      <span class="est-caret" :class="{ 'est-caret-aberto': expandido }">›</span>
      <span class="est-nome">{{ no.nome }}</span>
      <span class="est-tipo">{{ no.tipo }}</span>
    </div>

    <div v-if="expandido" class="est-painel">
      <div v-if="no.codigoEmbracon" class="est-codigo">Código Embracon: {{ no.codigoEmbracon }}</div>

      <div class="est-campo"><label>Razão social</label><span>{{ no.razaoSocial || '—' }}</span></div>
      <div class="est-campo"><label>CNPJ</label><span>{{ no.cnpj || '—' }}</span></div>
      <div class="est-campo"><label>CNPJ do Master vinculado</label><span :style="{color: no.cnpjMasterNome === '—' ? '#c0392b' : '#333'}">{{ no.cnpjMasterNome }}</span></div>
      <div class="est-campo"><label>Empresa superior</label><span>{{ no.superiorNome }}</span></div>
      <div class="est-campo" v-if="no.filhos.length"><label>Subordinadas</label><span>{{ no.filhos.map(f => f.nome).join(', ') }}</span></div>
      <div class="est-campo"><label>Status</label><span>{{ no.status }}</span></div>

      <div v-if="no.percentuais.length" class="est-campo">
        <label>Comissão</label>
        <div class="est-comissao">
          <div v-for="p in no.percentuais" :key="p.nome" class="est-comissao-linha">
            <span>{{ p.nome }}</span><strong>{{ p.percentual }}%</strong>
          </div>
        </div>
      </div>
      <div v-else class="est-campo"><label>Comissão</label><span>Nenhuma regra vigente configurada</span></div>

      <div class="est-acoes">
        <button @click.stop="$emit('editar', no)">Editar</button>
        <button @click.stop="$emit('adicionar-subordinado', no)">Adicionar subordinado</button>
        <button @click.stop="$emit('codigo-embracon', no)">Código Embracon</button>
        <button @click.stop="$emit('configurar-comissao', no)">Configurar comissão</button>
        <button @click.stop="$emit('excluir', no)" style="background:#f6d9d4;color:#c0392b;">Excluir</button>
      </div>
    </div>

    <div v-if="expandido && no.filhos.length" class="est-filhos">
      <MasterEstruturaNo
        v-for="filho in no.filhos"
        :key="filho.id"
        :no="filho"
        @editar="$emit('editar', $event)"
        @adicionar-subordinado="$emit('adicionar-subordinado', $event)"
        @codigo-embracon="$emit('codigo-embracon', $event)"
        @configurar-comissao="$emit('configurar-comissao', $event)"
        @excluir="$emit('excluir', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MasterEstruturaNo',
  props: { no: { type: Object, required: true } },
  emits: ['editar', 'adicionar-subordinado', 'codigo-embracon', 'configurar-comissao', 'excluir'],
  data() {
    return { expandido: false }
  }
}
</script>

<style scoped>
.est-no { border-bottom: 1px solid #f0f1ec; }
.est-linha { display: flex; align-items: center; gap: 8px; padding: 11px 4px; cursor: pointer; }
.est-caret { display: inline-block; font-size: 16px; color: #9aa08c; transition: transform .15s; }
.est-caret-aberto { transform: rotate(90deg); }
.est-nome { font-size: 13px; font-weight: 700; color: #28331a; }
.est-tipo { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .03em; color: #6b7a57; background: #eef2e6; padding: 2px 8px; border-radius: 4px; }
.est-painel { padding: 4px 4px 14px 28px; }
.est-codigo { font-size: 11px; color: #6b7a57; font-weight: 600; margin-bottom: 8px; }
.est-campo { font-size: 12px; margin-bottom: 7px; display: flex; flex-wrap: wrap; gap: 4px; }
.est-campo label { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .03em; color: #9aa08c; width: 100%; }
.est-comissao { display: flex; flex-direction: column; gap: 3px; margin-top: 2px; }
.est-comissao-linha { display: flex; justify-content: space-between; font-size: 12px; background: #f8f9f6; border-radius: 4px; padding: 5px 8px; max-width: 260px; }
.est-acoes { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.est-acoes button { margin: 0; padding: 6px 10px; font-size: 11px; background: #e8e8e2; color: #555; }
.est-filhos { padding-left: 20px; border-left: 1px solid #e8e8e2; margin-left: 10px; }
</style>
